import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Portal } from 'react-overlays';

import moment from 'moment';

import DatePicker from 'react-datepicker';

class DateAndTimePickerSmall extends Component {
  state = {
    startDate: null,
  };

  componentDidMount() {
    const {
      existingDate, handleDate,
    } = this.props;
    if (existingDate) {
      const startDate = new Date(existingDate);
      this.setState({
        startDate,
      });
      handleDate(moment(startDate).format());
    } else {
      handleDate(null);
    }
  }

  handleChange = (date) => {
    const { handleDate } = this.props;
    this.setState({
      startDate: date,
    });
    const formattedDate = date ? moment(date) : null;
    handleDate(formattedDate);
  };


  CalendarContainer({ children }) {
    const el = document.getElementById('calendar-portal');
    return <Portal container={el}>{children}</Portal>;
  }

  render() {
    const {
      title, action, reset, className, resetButtonStyle,
    } = this.props;
    const { startDate } = this.state;
    return (
      <div className="">
        <DatePicker
          selected={startDate}
          onChange={this.handleChange}
          showTimeSelect
          showYearDropdown
          // fixedHeight
          timeFormat="HH:mm"
          timeIntervals={15}
          dateFormat="MMMM d, yyyy h:mm aa"
          timeCaption="time"
          className={`${(action === 'display' || action === 'delete') && 'bg-grey'} px-6 py-2 outline-none rounded-full w-full text-sm ${className || 'mx-4'}`}
          // withPortal
          disabled={action === 'display' || action === 'delete'}
          // popperClassName="z-index: 10000000 !important"
          placeholderText={title}
          // popperProps={{
          //   zIndex: 99999999, // use this to make the popper position: fixed
          // }}
          popperContainer={this.CalendarContainer}
        />
        {reset && (
          <button
            type="button"
            className={`${resetButtonStyle} font-americaMonoBold text-xxs mx-4 px-6 py-1 rounded-full bg-grey text-black uppercase bg-greyFilter mb-1 mt-1`}
            onClick={() => {
              this.setState({ startDate: null });
              reset();
            }}
          >
            Reset
          </button>
        )}
      </div>
    );
  }
}

DateAndTimePickerSmall.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  existingDate: PropTypes.string,
  handleDate: PropTypes.func.isRequired,
  reset: PropTypes.func,
  className: PropTypes.string,
  resetButtonStyle: PropTypes.string,
};

DateAndTimePickerSmall.defaultProps = {
  existingDate: '',
  reset: null,
  className: '',
  resetButtonStyle: '',
};

export default DateAndTimePickerSmall;
